export default {"src":"/_next/static/media/star.4c21ab4f.svg","height":23,"width":24};